import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Db } from "../firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  limit,
} from "firebase/firestore";
import { Container, Row, Col } from "react-bootstrap";
import {
  Facebook,
  Instagram,
  Youtube,
  Spotify,
  Share,
} from "react-bootstrap-icons";
import OptimizedImage from "./ΟptimizedImage";
import "./Compoments.css";

const ArticlePage = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        // 🧩 1️⃣ Προσπάθησε να βρεις άρθρο βάσει slug
        const q = query(collection(Db, "posts"), where("slug", "==", slug));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const docSnap = snapshot.docs[0];
          const data = docSnap.data();
          console.log("📄 Article (via slug):", data);
          setArticle(data);
          fetchRelated(data, docSnap.id);
        } else {
          // 🧩 2️⃣ Αν δεν βρεθεί, δοκίμασε ως ID (backwards compatibility)
          const docRef = doc(Db, "posts", slug);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            console.log("📄 Article (via ID fallback):", data);
            setArticle(data);
            fetchRelated(data, docSnap.id);
          } else {
            console.error("❌ Δεν βρέθηκε άρθρο ούτε με slug ούτε με id:", slug);
          }
        }
      } catch (error) {
        console.error("🔥 Σφάλμα κατά την ανάκτηση άρθρου:", error);
      }
    };

    const fetchRelated = async (data, currentId) => {
      try {
        if (!data?.genre) {
          console.warn("⚠️ Το άρθρο δεν έχει genre – παραλείπεται related query.");
          setRelated([]);
          return;
        }

        const q = query(
          collection(Db, "posts"),
          where("genre", "==", data.genre),
          limit(3)
        );
        const relatedSnap = await getDocs(q);
        const rel = relatedSnap.docs
          .filter((d) => d.id !== currentId)
          .map((d) => ({ id: d.id, ...d.data() }));
        setRelated(rel);
      } catch (err) {
        console.error("⚠️ Σφάλμα στο related fetch:", err);
      }
    };

    fetchArticle();
  }, [slug]);

  if (!article) return <p className="text-center mt-5">Loading...</p>;

  const shareUrl = window.location.href;
  const socials = article.socials || {};

  return (
    <Container className="my-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h2 className="fw-bold mb-2">{article.title}</h2>

          <div className="text-muted mb-3">
            {article.category && (
              <>
                <Link
                  to={`/archive/${article.category}`}
                  className="text-decoration-none me-2 text-uppercase fw-semibold"
                >
                  {article.category}
                </Link>
                {article.genre && (
                  <>
                    {">"}
                    <Link
                      to={`/archive/${article.category}/${article.genre}`}
                      className="text-decoration-none ms-2"
                    >
                      {article.genre}
                    </Link>
                  </>
                )}
              </>
            )}
          </div>

          <p className="fw-semibold mb-4">✍️ {article.author}</p>

          {(article.mainImageUrl || article.image) && (
            <img
              src={article.mainImageUrl || article.image}
              alt={article.title}
              className="img-fluid rounded mb-4"
            />
          )}

          {/* === Περιεχόμενο === */}
          <div
            className="article-body mb-4"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          {/* === Social Links === */}
          <div className="d-flex gap-3 mb-4">
            {socials.instagram && (
              <a href={socials.instagram} target="_blank" rel="noreferrer">
                <Instagram size={24} />
              </a>
            )}
            {socials.facebook && (
              <a href={socials.facebook} target="_blank" rel="noreferrer">
                <Facebook size={24} />
              </a>
            )}
            {socials.youtube && (
              <a href={socials.youtube} target="_blank" rel="noreferrer">
                <Youtube size={24} />
              </a>
            )}
            {socials.spotify && (
              <a href={socials.spotify} target="_blank" rel="noreferrer">
                <Spotify size={24} />
              </a>
            )}
          </div>

          <hr />

          {/* === Share Links === */}
          <div className="d-flex align-items-center mb-4 gap-2">
            <Share size={20} />
            <span className="fw-semibold">Share:</span>
            <a
              href={`https://facebook.com/sharer/sharer.php?u=${shareUrl}`}
              target="_blank"
              rel="noreferrer"
            >
              <Facebook />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${shareUrl}`}
              target="_blank"
              rel="noreferrer"
            >
              X
            </a>
            <a
              href={`https://reddit.com/submit?url=${shareUrl}`}
              target="_blank"
              rel="noreferrer"
            >
              Reddit
            </a>
          </div>

          {/* === Related === */}
          {related.length > 0 && (
            <>
              <h4 className="fw-bold mt-5 mb-3">Read More</h4>
              <Row>
                {related.map((post) => (
                  <Col md={4} key={post.id}>
                    <div className="card border-0 mb-4">
                      {(post.mainImageUrl || post.image) && (
                        <OptimizedImage
                          src={post.mainImageUrl || post.image}
                          alt={post.title}
                          className="card-img-top rounded"
                        />
                      )}
                      <div className="card-body px-0">
                        <h6 className="fw-semibold">
                          <Link
                            to={`/articles/${post.slug || post.id}`}
                            className="text-decoration-none"
                          >
                            {post.title}
                          </Link>
                        </h6>
                        <small className="text-muted">{post.genre}</small>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ArticlePage;
